import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconSavedOn = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M12 22.3401L11.33 21.7501C10.37 20.9001 2 13.2801 2 8.01012C2 5.40012 3.28 3.31012 5.42 2.42012C7.52 1.55012 9.98 2.03012 12 3.66012C14.02 2.03012 16.47 1.55012 18.58 2.42012C20.72 3.31012 22 5.40012 22 8.01012C22 13.2801 13.62 20.9001 12.67 21.7501L12 22.3401Z" }))));
};
